import request from '../../utils/Request';
import { Methods } from '../../config';

const baseURL = 'workspace';

const workspaceService = {
  getWorkspaceData: (projectId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(projectId)}`,
    });
  },
  getTaskById: (simpleTaskId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/task/${encodeURIComponent(simpleTaskId)}`,
    });
  },
  getOverviewData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/overview`,
      data,
    });
  },

  updateTask: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/task`,
      formData: true,
      data,
    });
  },
};

export default workspaceService;
